'use strict';

const _ = require('underscore');
const HolyMenu = require('common/ui/view/svg/menu/holy');
const MenuIcon = require('common/ui/view/svg/menu/icon');

module.exports = HolyMenu.extend({
    initialize: function(params) {
        this.constructor.__super__.initialize.call(this, params);
        _.bindAll(this, '_zone', '_node', '_type', '_cancel',
            '_moveto', '_comment');

        let zone = null;
        if(params.isZone) {
            zone = {
                name: 'node',
                icon: MenuIcon.fontAwesomeIcon(
                    'fa fa-square',
                    {
                        color: '#888'
                    }
                ),
                click: this._node,
                text: 'view/diagram:menu.node.node'
            };
        } else {
            zone = {
                name: 'zone',
                icon: MenuIcon.fontAwesomeIcon(
                    'fa fa-square-o',
                    {
                        color: '#888'
                    }
                ),
                click: this._zone,
                text: 'view/diagram:menu.node.zone'
            };
        }

        this.menus = [
            {
                name: 'type',
                icon: MenuIcon.fontAwesomeIcon(
                    'fa fa-refresh',
                    {
                        color: '#888'
                    }
                ),
                click: this._type,
                text: 'view/diagram:menu.node.type'
            },
            {
                name: 'comment',
                icon: MenuIcon.fontAwesomeIcon(
                    'fa fa-comment',
                    {
                        color: '#888'
                    }
                ),
                click: this._comment,
                text: 'view/diagram:menu.node.comment'
            },
            zone,
            {
                name: 'cancel',
                icon: MenuIcon.fontAwesomeIcon(
                    'fa fa-fast-backward',
                    {
                        color: '#888'
                    }
                ),
                click: this._cancel,
                text: 'view/diagram:menu.node.cancel'
            },
            {
                name: 'moveto',
                icon: MenuIcon.fontAwesomeIcon(
                    'fa fa-location-arrow',
                    {
                        color: '#888'
                    }
                ),
                click: this._moveto,
                text: 'view/diagram:menu.node.moveto'
            }
        ]
    },

    _zone: function(menu) {
        this.trigger('zone', menu);
    },
    _node: function(menu) {
        this.trigger('node', menu);
    },
    _type: function(menu) {
        this.trigger('type', menu);
    },
    _comment: function(menu) {
        this.trigger('comment', menu);
    },
    _cancel: function(menu) {
        this.trigger('cancel', menu);
    },
    _moveto: function(menu) {
        this.trigger('moveto', menu);
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/menu/node-edit.js